import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { QuestionAnswer, TopicAnswers } from '@app/_models';
import { CourseService } from '@app/_services/course.service';
import { TopicShareService } from '@app/_services/topic.share.service';
import { first } from 'rxjs/operators';

@Component({ templateUrl: 'topic.component.html', selector: 'topic'})
export class TopicComponent {
    
    loading = false;
    sectionId:any;
    topic:any;
    theme:any = "dark";
    topicAnswers: TopicAnswers;

    constructor(private route: ActivatedRoute, private courseService: CourseService, private shareService: TopicShareService) { }

    ngOnInit() {
        
        this.topicAnswers = new TopicAnswers();

        this.route.paramMap.subscribe(params => {
            this.sectionId = params.get('id');
            this.getTopic();
        });
    }

    getTopic() {
        this.courseService.getTopic(this.sectionId).pipe(first()).subscribe(data => {
            this.loading = false;
            this.topic = data.section;
            this.theme = data.theme.toLowerCase();
            
            this.topicAnswers = new TopicAnswers();
            this.topicAnswers.topicId = this.topic.id;
            this.topicAnswers.answers = this.topic.questions.map(q => {
                var questionAnswer = new QuestionAnswer();
                questionAnswer.questionText = q.questionText;
                questionAnswer.placeholder = q.placeholder;
                questionAnswer.questionId = q.id;
                
                var answerResult = data.answers.find(a => {
                    return a.question.id == q.id;
                });
                
                if(answerResult){
                    questionAnswer.answer = answerResult.answer;
                    questionAnswer.answerId = answerResult.answerId;
                } else {
                    questionAnswer.answerId = 0;
                }

                    
                return questionAnswer;
            });
            this.shareService.emitter.emit(this.isValidSection());
        });
    }

    answerChanged(answer, answerId, index){
        if(answerId == 0) {
            this.topicAnswers.answers[index].answer = answer.answer.target.value;
        } else {
            this.topicAnswers.answers.find(a => a.answerId == answerId).answer = answer.answer.target.value
        }

        this.shareService.emitter.emit(this.isValidSection());
    }

    isValidSection() {
        if(this.topicAnswers.answers) {

            for(var i=0; i<this.topicAnswers.answers.length; i++) {
                
                if(this.topicAnswers.answers[i]){
                    if(this.topicAnswers.answers[i].answer == undefined || this.topicAnswers.answers[i].answer.trim() == ""){
                        return false;
                    }
                } else {
                    return false;
                }
            }
            
            return true;

        } else {
            return true;
        }
    }

    save() {
        if (this.topicAnswers && this.topicAnswers.answers && this.topicAnswers.answers.length > 0)
            return this.courseService.postAnswers(this.sectionId, this.topicAnswers);
        else
            return this.courseService.addProgress(this.sectionId);
    }
} 